import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { Subject } from "rxjs";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "app-dialog",
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogComponent implements OnInit {
  onClose: Subject<string>;
  currentItem: any;
  cibmtrCenters: Array<any>;

  constructor(
    readonly dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) readonly data: { cibmtrCenters: any[] }
  ) {}

  ngOnInit() {
    this.onClose = new Subject();
    this.cibmtrCenters = this.data.cibmtrCenters;
    this.currentItem = this.cibmtrCenters[0];
  }

  selectRow(item) {
    this.cibmtrCenters.forEach((c) => {
      if (c.value === item.value) {
        this.currentItem = item;
      }
    });
    this.onClose.next("rowSelected");
  }

  public onContinue(): void {
    this.dialogRef.close(this.currentItem);
  }
}
